import React from 'react';
import { Space, Typography } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import Modal from './Modal';

const { Text, Title } = Typography;

const ConfirmationModal = ({
  open,
  onCancel,
  onConfirm,
  title = 'Confirmação',
  content,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning', // warning, danger, success, info
  loading = false,
  ...props
}) => {
  const { theme } = useTheme();

  // Ícones e cores baseados no tipo
  const getTypeConfig = () => {
    const configs = {
      warning: {
        icon: <ExclamationCircleOutlined style={{ fontSize: '24px', color: '#faad14' }} />,
        color: '#faad14',
        okButtonProps: { 
          style: { 
            backgroundColor: '#faad14', 
            borderColor: '#faad14',
            borderRadius: '6px'
          } 
        }
      },
      danger: {
        icon: <CloseCircleOutlined style={{ fontSize: '24px', color: '#ff4d4f' }} />,
        color: '#ff4d4f',
        okButtonProps: { 
          danger: true,
          style: { borderRadius: '6px' }
        }
      },
      success: {
        icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
        color: '#52c41a',
        okButtonProps: { 
          style: { 
            backgroundColor: '#52c41a', 
            borderColor: '#52c41a',
            borderRadius: '6px'
          } 
        }
      },
      info: {
        icon: <InfoCircleOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
        color: '#1890ff',
        okButtonProps: { 
          style: { 
            backgroundColor: '#1890ff', 
            borderColor: '#1890ff',
            borderRadius: '6px'
          } 
        }
      }
    };

    return configs[type] || configs.warning;
  };

  const typeConfig = getTypeConfig();

  return (
    <Modal
      title={
        <Space>
          {typeConfig.icon}
          <Title level={4} style={{ margin: 0, color: theme.textSecondary }}>
            {title}
          </Title>
        </Space>
      }
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={confirmText}
      cancelText={cancelText}
      variant="confirmation"
      loading={loading}
      okButtonProps={typeConfig.okButtonProps}
      cancelButtonProps={{ style: { borderRadius: '6px' } }}
      {...props}
    >
      <div style={{ padding: '8px 0' }}>
        <Text style={{ fontSize: '15px', lineHeight: '1.6' }}>
          {content}
        </Text>
      </div>
    </Modal>
  );
};

export default ConfirmationModal; 